import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-rows" }
const _hoisted_2 = { class: "row col-xs-12 col-md-9 s-form-input_wrapper wrap-anyway" }
const _hoisted_3 = { class: "row col-xs-4 justify-end" }

import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import Draggable from 'vuedraggable';
import { TableRowType } from 'SharedDir/declarations/fields';
import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import { computed } from 'vue';
import { DELAY_TOOLTIP } from 'SharedDir/constants/common';

import TableRow from 'SharedDir/service/fields/_Table/table-row';
import TableRowItem from 'SharedDir/service/fields/_Table/TableRow.vue';

interface Props extends PropValue<null | Array<TableRowType>> {
  readonly?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'TableRowsParameter',
  components: {
    TableRowItem,
    Draggable,
  },
},
  __name: 'TableRows',
  props: {
    readonly: { type: Boolean, default: false },
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const castValue = (value: null | Array<TableRowType>): Array<TableRow> =>
  (value || []).map((row) => new TableRow(row));



const props = __props;
const emits = __emit;
const { innerValue, emitValue } = useValue(props, emits, { transform: castValue });

const delayTooltip = DELAY_TOOLTIP;

const sumIsSet = computed(() => innerValue.value.filter((row) => row.isSummary).length > 0);

const addRow = () => {
  innerValue.value.push(new TableRow({ order: innerValue.value.length }));
  emitValue();
};

const refreshRowsOrder = () => {
  innerValue.value.forEach((row, index) => {
    // eslint-disable-next-line no-param-reassign
    row.order = index;
  });
  emitValue();
};

const removeRow = (index: number) => {
  innerValue.value.splice(index, 1);
  emitValue();
};

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row col-xs-8 justify-start items-center s-text-title" }, "Строки таблицы", -1)),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.readonly)
          ? (_openBlock(), _createBlock(SBtn, {
              key: 0,
              "no-caps": "",
              type: "brand",
              icon: "add",
              onClick: addRow
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, {
                  "content-class": "s-tooltip",
                  delay: _unref(delayTooltip)
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Добавить строку таблицы ")
                  ])),
                  _: 1
                }, 8, ["delay"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_unref(Draggable), {
      modelValue: _unref(innerValue),
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(innerValue) ? (innerValue).value = $event : null)),
      "item-key": "id",
      tag: "div",
      class: "row col-xs-12 col-md-9 s-form-input_wrapper wrap-anyway",
      "ghost-class": "section-field__item--ghost",
      "draggable-class": "section-field__item--draggable",
      animation: "200",
      disabled: _ctx.readonly,
      easing: "cubic-bezier(1, 0, 0, 1)",
      onEnd: refreshRowsOrder
    }, {
      item: _withCtx(({ index }) => [
        _createVNode(TableRowItem, {
          modelValue: _unref(innerValue)[index],
          "onUpdate:modelValue": [($event: any) => ((_unref(innerValue)[index]) = $event), _unref(emitValue)],
          class: "base-margin-bottom",
          readonly: _ctx.readonly,
          "sum-is-set": sumIsSet.value,
          onRemove: _cache[0] || (_cache[0] = ($event: any) => (removeRow(_ctx.i)))
        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "sum-is-set"])
      ]),
      _: 1
    }, 8, ["modelValue", "disabled"])
  ]))
}
}

})